export default __webpack_public_path__ + "static/media/Detail-SBS.f6fa68da.png";